<template>
  <!-- Page length options -->
  <div class="card">
    <div 
      v-show="onload" 
      class="content bg-white"
    >
      <placeholder-content is-load="true" />
    </div>
    <div v-if="!onload && hasPermission">
      <access-denied />
    </div>
    <div
      v-show="!onload && !hasPermission"
      class="card-header header-elements-inline border-bottom bg-white"
    >
      <h5 class="card-title">
        {{ $t("Cash on Delivery Payment Report (COD)") }}
      </h5>
    </div>
    <div v-show="!onload && !hasPermission">
      <div class="flex-wrap pl-3 pt-3 bg-light">
        <tab-cod-over-views
          :start-date="dateRange.startDate"
          :end-date="dateRange.endDate"
        />
      </div>
      <div class="card-body px-0 pb-0 pt-0">
        <ul
          class="nav nav-tabs nav-tabs-bottom border-bottom-0 pl-3 border-top"
        >
          <li
            v-for="(tabs, index) in tabLabel"
            :key="`tabs-${index}`"
            class="nav-item"
            :class="[$route.query.reportType == tabs.value ? 'active' : '']"
          >
            <a
              href="#bottom-divided-tab1"
              @click="tabshow(tabs.value)"
              data-toggle="tab"
              :class="['nav-link cursor-pointer', $route.query.reportType == tabs.value ? 'active' : '']"
            >
              <i :class="['mr-2', tabs.icon]" />{{ tabs.text
              }}<span :class="[tabs.badge, 'ml-2']">{{
                count[tabs.value]
              }}</span>
            </a>
          </li>
        </ul>
        <div class="btn-group flex-wrap w-100 py-3 px-3 bg-light border-top">
          <!-- search -->
          <div class="toobar-search pr-2">
            <div class="input-group bg-white">
              <input
                type="text"
                @keydown.enter.prevent="search()"
                v-model="paramsQuery.search"
                name="search"
                :placeholder="$t('Tracking No. Search')"
                style="min-width: 400px"
                class="border-right-0 form-control pl-2 px-0"
              >
              <span class="input-group-append">
                <button
                  class="btn btn-outline-normal border-left-0 btn-search"
                  type="button"
                  @click="search"
                >
                  <i class="far fa-search" />
                </button>
              </span>
            </div>
          </div>

          <!-- filter calendar -->
          <div class="toolbar-filter">
            <div class="btn-group">
              <div class="filter-date">
                <div class="input-group">
                  <span class="ml-3 mr-2 d-flex align-items-center">{{
                    $t("Data Duration")
                  }}</span>
                  <span class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-calendar-alt" />
                    </span>
                  </span>
                  <date-range-picker
                    style="min-width: 175px"
                    :ranges="ranges"
                    v-model="dateRange"
                    :locale-data="localedata"
                    :control-container-class="'form-control rounded-left-0'"
                    @update="applyDatePicker"
                  >
                    <div 
                      slot="input" 
                      v-html="showTextPicker" 
                    />
                    <div
                      slot="footer"
                      slot-scope="data"
                      class="p-2 drp-buttons"
                    >
                      <button
                        @click="cancelDateRange()"
                        v-if="!data.in_selection"
                        type="button"
                        class="applyBtn btn btn-sm btn-secondary"
                      >
                        {{ $t("Cancel") }}
                      </button>
                      <button
                        @click="data.clickApply"
                        v-if="!data.in_selection"
                        type="button"
                        class="applyBtn btn btn-sm btn-primary"
                      >
                        {{ $t("Apply") }}
                      </button>
                    </div>
                  </date-range-picker>
                  <Select2
                    v-if="activeTab == 'return'"
                    style="min-width: 175px"
                    class="bg-white"
                    v-model="paramsQuery.date_type"
                    :options="dateType" 
                    :settings="dateTypeSetting"
                    @change="changeDateTypeEvent($event)"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="btn-group" role="group">
                    <button type="button" class="btn border-left-0 btn-outline-normal rounded-left-0 d-flex"
                        data-toggle="modal" data-target="#advance_filter"><i class="fas fa-sliders-v mr-2 mt-1"></i>
                        {{$t("More Filters")}}</button>
                </div> -->
          <!-- perpage -->
          <div class="dataTables_length ml-auto mb-0">
            <PerPage @per-page="setPerPage" />
          </div>
        </div>
      </div>
      <div
        :class="['table-responsive mt-0 data-nowrap table-order']"
        id="table-order"
      >
        <div class="vuetable-wrapper datatable-scroll">
          <vuetable
            :class="[loadingTable]"
            ref="vuetable"
            :no-data-template="$t('No Data Available')"
            :fields="table.fields"
            data-path="data"
            pagination-path=""
            :api-mode="false"
            :data-manager="dataManager"
            @vuetable:loaded="vuetableLoaded"
            @vuetable:loading="vuetableLoading"
            @vuetable:pagination-data="onPaginationData"
          >
            <template 
              slot="bank_name" 
              slot-scope="props"
            >
              <img
                v-if="!bankResult[props.rowIndex]"
                class="rounded pointer"
                width="25"
                height="25"
                :src="$storeIndex.getImageGobalAssets('')"
                alt=""
              >

              <img
                v-else
                :src="bankResult[props.rowIndex]"
                width="20"
                height="20"
              >

              {{ props.rowData.bank_name }}
            </template>
            <template 
              slot="billing_no" 
              slot-scope="props"
            >
              <router-link
                :to="{
                  name: 'admin.reports.payments.cashOnDeliveryDetail',
                  params: { 
                    id: props.rowData.reconcile_id,
                    cod_account_id: props.rowData.cod_account_id
                  },
                }"
                target="_blank"
              >
                {{ props.rowData.billing_no }}
              </router-link>
            </template>
            <div 
              slot="action" 
              slot-scope="props"
            >
              <div class="list-icons">
                <div class="dropdown">
                  <a 
                    href="#" 
                    class="list-icons-item" 
                    data-toggle="dropdown"
                  >
                    <i class="icon-menu9" />
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      href="javascript:void(0);"
                      @click="handleDownload(props.rowData.reconcile_id, props.rowData.cod_account_id)"
                      class="dropdown-item"
                    >
                      <i class="fa-solid fa-file-arrow-down" />
                      {{ $t("Download") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </vuetable>
        </div>
        <div class="datatable-footer">
          <vuetable-pagination-info
            class="dataTables_info"
            ref="paginationInfo"
            :no-data-template="$t('No relevant data')"
            :info-template="$t('Displaying {from} to {to} of {total} items')"
          />
          <div class="dataTables_paginate paging_simple_numbers mb-0">
            <vuetable-pagination
              ref="pagination"
              pagination-path="pagination"
              @vuetable-pagination:change-page="onChangePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import DateRangePicker from "vue2-daterange-picker";
import PerPage from "../PerPage.vue";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import codFieldsAll from "../assets/js/cod_fields_all.js";
import codFieldsWaiting from "../assets/js/cod_fields_waiting.js";
import codFieldsTransfer from "../assets/js/cod_fields_transfer.js";
import codFieldsOnReturn from "../assets/js/cod_fields_return.js";
import TabCodOverViews from "./TabCodOverViews.vue";
import { showTextPicker } from "../assets/directives/Vuetable.js";
import moment from "moment";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import { tHeader, filterVal } from "../assets/js/xlsx.js";
import numeral from "numeral";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import Select2 from "v-select2-component";

export default {
  name: "CodIndex",
  components: {
    DateRangePicker,
    PerPage,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    TabCodOverViews,
    AccessDenied,
    Select2
  },
  data() {
    return {
      activeTab: "all",
      defaultStartDate: moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD 17:00:00"),
      defaultEndDate: moment().format("YYYY-MM-DD 16:59:59"),
      tabLabel: [
        {
          value: "all",
          text: this.$t("All"),
          icon: "far fa-globe-asia mr-2",
          badge: "badge badge-dark ml-2",
        },
        {
          value: "waiting",
          text: this.$t("Waiting for transfer"),
          icon: "fas fa-clock mr-2",
          badge: "badge bg-orange-400 ml-2",
        },
        {
          value: "transfer",
          text: this.$t("Money transferred"),
          icon: "fas fa-check-circle",
          badge: "badge  bg-success  ml-2",
        },
        {
          value: "return",
          text: this.$t("On Return"),
          icon: "fa-solid fa-arrow-rotate-left",
          badge: "badge badge-danger ml-2",
        },
      ],
      count: {
        all: 0,
        waiting: 0,
        transfer: 0,
        return: 0,
      },
      checkedCount: 0,
      fields: {
        all: codFieldsAll,
        waiting: codFieldsWaiting,
        transfer: codFieldsTransfer,
        return: codFieldsOnReturn,
      },
      table: {
        fields: codFieldsAll,
      },
      paramsQuery: {
        search: null,
        start_date: moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD 17:00:00"),
        end_date: moment().format("YYYY-MM-DD 16:59:59"),
        per_page: 10,
        current_page: 1,
        sort: "",
        page: 1,
        reportType: "all",
        date_type: "sales_order_created_date",
      },
      dateRange: {
        startDate: this.defaultStartDate,
        endDate: this.defaultEndDate,
      },
      dateType: [
        {
          text: this.$t('Order Date'),
          id: "sales_order_created_date",
        },
        {
          text: this.$t('Create Shipment Date'),
          id: "create_shipment_date",
        },
        {
          text: this.$t('Returned Date'),
          id: "returned_date",
        }
      ],
      dateTypeSetting: {
          minimumResultsForSearch: Infinity,
          placeholder: this.$t("Date Type") + "..",
      },
      sort: [
        {
          field: "id",
          direction: "desc",
        },
      ],
      onload: true,
      hasPermission: false,
      ranges: this.$storeIndex.ranges(),
      localedata: {
        format: "yyyy-mm-dd",
        cancelLabel: this.$t("Cancel"),
      },
      dateTxtFilter: null,
      loadingTable: null,
      i: 0,
      bankList: [],
      bankResult: [],
      tHeader: null,
      filterVal: null,
      list: null,
      filename: "COD Export - Goship",
      autoWidth: true,
      bookType: "xlsx",
    };
  },
  computed: {
    showTextPicker: function () {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.dateRange.startDate = convertTimezone.utcToLocal(
          this.dateRange.startDate
        );
        this.dateRange.endDate = convertTimezone.utcToLocal(
          this.dateRange.endDate
        );
        this.dateTxtFilter = showTextPicker(this.dateRange);
        return this.dateTxtFilter;
      } else {
        return showTextPicker(this.paramsQuery);
      }
    },
  },
  methods: {
    dataManager(sortOrder, pagination) {
      if (sortOrder.length > 0) {
        this.paramsQuery.sort = sortOrder
          .map((item) => `${item.sortField}|${item.direction}`)
          .join(",");
      }
      this.setParams();
    },
    changeDateTypeEvent(val) {
      this.setParams();
    },
    onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
      this.count[this.paramsQuery.reportType] = tablePagination.total;
    },
    onChangePage(page) {
      this.paramsQuery.page = page;
      this.$refs.vuetable.changePage(page);
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter((field) => field.togglable);
    },
    search() {
      this.setParams();
    },
    setPerPage(perPage) {
      this.paramsQuery.current_page = 1;
      this.$refs.vuetable.currentPage = 1;
      this.paramsQuery.per_page = perPage;
      this.setParams();
    },
    vuetableLoaded() {
      // this.onload = false;
    },
    vuetableLoading() {},
    cancelDateRange() {
      this.paramsQuery.start_date = this.defaultStartDate;
      this.paramsQuery.end_date = this.defaultEndDate;
      $(".daterangepicker").remove();
      this.setParams();
    },
    applyDatePicker(dateRange) {
      let startDate = this.paramsQuery.start_date
        ? moment(dateRange.startDate).format("YYYY-MM-DD")
        : null;
      let endDate = this.paramsQuery.end_date
        ? moment(dateRange.endDate).format("YYYY-MM-DD")
        : null;
      var afterStartDate = startDate + " 00:00:00";
      var afterEndDate = endDate + " 23:59:59";
      this.paramsQuery.start_date = convertTimezone.localToUtc(afterStartDate);
      this.paramsQuery.end_date = convertTimezone.localToUtc(afterEndDate);
      this.setParams(1);
    },
    async setParams(page = null) {
      try {
        this.loadingTable = "loading";
        if (page == null) {
          this.paramsQuery.page = this.$refs.vuetable.currentPage;
        } else {
          this.paramsQuery.page = page;
          this.$refs.vuetable.currentPage = page;
        }
        let queryString = "";

        if (this.paramsQuery) {
          queryString += "?" + $.param(this.paramsQuery);
        }

        this.setQuerystring(this.paramsQuery);

        // let data = this.$storeIndex.mutations.vueTableFormatJson(
        let data = await Api.Report.getCodReconcile(queryString);
        // );

        const bankList = await Api.Bank.getBank();
        this.bankList = bankList.data.data;

        let vm = this;
        var result = [];

        if (data.data.length != 0) {
          data.data.data.forEach(function (bank) {
            var logo = vm.bankList.find((x) => x.code == bank.bank_code);

            if (logo != undefined) {
              result.push(logo.logo);
            } else {
              result.push(null);
            }
          });

          this.bankResult = result;
        }
        this.$refs.vuetable.setData(data.data);

        this.loadCountTab();
        this.loadingTable = "";
        this.hasPermission = false;
        this.onload = false;
      } catch (error) {
        console.error('setparam-cod', error);

        if (error.response.status == 403) {
          this.hasPermission = true;
          this.onload = false;
        } else {
          this.$router.push({name: "t.a.home"});
          console.log(error.response, "error2");
        }
      }
    },
    tabshow(status) {
      this.table.fields = this.fields[status];
      this.paramsQuery.reportType = status;
      this.activeTab = status;
      this.setParams(1);
    },
    async loadCountTab() {
      for await (const tab of this.tabLabel) {
        let response = await Api.Report.getCodReconcile(
          "?" +
            $.param({
              reportType: tab.value,
              start_date: this.paramsQuery.start_date,
              end_date: this.paramsQuery.end_date,
            })
        );
        this.count[tab.value] = response.data.total ? response.data.total : 0;
      }
    },
    setQuerystring(obj) {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, obj),
        })
        .catch(() => {});
    },

    async getBank() {
      const bankList = await Api.Bank.getBank();
      this.bankList = bankList;
    },
    async handleDownload(id, codAccountId) {
      let postHasPermission = await Api.Permission.postHasPermission(
        "payment_report_by_cod_download"
      );
      if (postHasPermission.data.status) {
        this.fetchData(id, codAccountId);
      } else {
        var titleMessage = this.$t("Access Denied");
        var htmlMessage = this.$t(
          "You do not have permission to access this page."
        );
        var self = this;
        this.$swal.fire({
          title: titleMessage,
          icon: "warning",
          iconColor: "#FF7043",
          html: htmlMessage,
          showCancelButton: true,
          confirmButtonText:
            '<i class="fas fa-redo mr-2"></i>' + self.$t("Try again"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
            loader: "custom-loader",
          },
          loaderHtml: '<div class="spinner-border text-primary"></div>',
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return await Api.Permission.postHasPermission(
              "payment_report_by_cod_download"
            ).then((response) => {
              if (response.data.status) {
                self.fetchData(id, codAccountId);
              } else {
                self.$swal.showValidationMessage(self.$t("Permission denied."));
              }
            });
          },
        });
      }
    },
    fetchData(id, codAccountId) {
      let queryString = "";

      if (this.paramsQuery) {
        if (this.paramsQuery.start_date && this.paramsQuery.end_date) {
          let startDate = this.paramsQuery.start_date
            ? moment(this.paramsQuery.start_date).format("YYYY-MM-DD")
            : null;
          let endDate = this.paramsQuery.end_date
            ? moment(this.paramsQuery.end_date).format("YYYY-MM-DD")
            : null;

          var afterStartDate = startDate + " 00:00:00";
          var afterEndDate = endDate + " 23:59:59";

          this.paramsQuery.start_date =
            convertTimezone.localToUtc(afterStartDate);
          this.paramsQuery.end_date = convertTimezone.localToUtc(afterEndDate);
        }
      }

      if (this.paramsQuery) {
        queryString += "?" + $.param(this.paramsQuery);
      }

      Api.Report.getCodReconcileView(
        "?" +
          $.param({
            search: "",
            start_date: this.paramsQuery.start_date,
            end_date: this.paramsQuery.end_date,
            per_page: 5000,
            current_page: this.paramsQuery.current_page,
            sort: this.paramsQuery.sort,
            reportType: this.paramsQuery.reportType,
          }),
        id,
        codAccountId
      ).then((response) => {
        // Api.Report.getCodReconcileView(queryString,id).then(response => {
        this.list = response.data.data;
        import("../assets/js/Export2Excel.js").then((excel) => {
          const tHeader = this.tHeader;
          const filterVal = this.filterVal;
          const list = this.list;
          const data = this.formatJson(filterVal, list);
          data.forEach((element) => {
            element[1] = element[1]
              ? convertTimezone.utcToLocal(element[1])
              : "-";
            element[2] = element[2]
              ? convertTimezone.utcToLocal(element[2])
              : "-";
            element[7] = numeral(element[7]).format("0,0.00");
            element[8] = numeral(element[8]).format("0,0.00");
          });
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          const jArr = j.split(".");
          if (jArr.length > 1) {
            return v[jArr[0]][[jArr[1]]];
          }

          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  },
  async mounted() {
    this.dateRange.startDate = this.paramsQuery.start_date = this.$route.query
      .start_date
      ? this.$route.query.start_date
      : this.defaultStartDate;
    this.dateRange.endDate = this.paramsQuery.end_date = this.$route.query
      .end_date
      ? this.$route.query.end_date
      : this.defaultEndDate;
    this.getBank();
    this.onload = true;
  },
  created() {
    this.tHeader = tHeader();
    this.filterVal = filterVal();
  },
};
</script>

<style scoped>
.input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  border-top-left-radius: 0.1875rem;
  border-bottom-left-radius: 0.1875rem;
}
.nav-item.active {
  border-bottom: 1px solid #333;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/Cod.vue